import React from 'react';
import PropTypes from 'prop-types';
import { Location } from '@reach/router';
import { Link } from 'gatsby';

const LinkWithPrevUrl = ({ children, state, ...rest }) => (
  <Location>
    {({ location }) => (
      <Link {...rest} state={{ previousHref: location.href, ...state }}>
        { children }
      </Link>
    )}
  </Location>
);

LinkWithPrevUrl.propTypes = {
  children: PropTypes.node.isRequired,
  state: PropTypes.object,
};

export default LinkWithPrevUrl;
